import { useTranslation } from 'react-i18next';

import { AGREEMENT_URL } from '@/utils/links';
import { TranslatedLink } from '@/utils/translatedComponents';
import styles from '../Settings.module.css';

export function TermsSection() {
  const { t } = useTranslation();

  return (
    <div className={`${styles.section} ${styles.lastSection}`}>
      <div className={styles.sectionInfo}>
        <div className={styles.sectionInfoTitle}>{t('account.termsSection.title')}</div>
      </div>
      <div className={styles.sectionBody} style={{ paddingTop: '5px' }}>
        <TranslatedLink href={AGREEMENT_URL} target="_blank">
          {t('inviteView.agreementLink')}
        </TranslatedLink>
      </div>
    </div>
  );
}
